import React from 'react'
import { Container } from 'react-bootstrap';
import BannerTitle from './../../font_component/banner_title/BannerTitle';
import "./ContactBanner.css"

export default function ContactBanner() {
  return (
     <div className="contact-banner">
      <Container className="text-center text-white">

        <BannerTitle
          firstText="Have Questions?"
          highlightText=" Get in Touch"
        />

      </Container>
    </div>
  )
}
